import React from "react"

interface Creditpoints {
  creditpoints?: number
}

export const Creditpoints: React.FC<Creditpoints> = ({ creditpoints }) =>
  creditpoints ? (
    <span class="inline ml-1">– {creditpoints}&nbsp;LP</span>
  ) : (
    <>{""}</>
  )
